import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import IndexPage from '../components/Portfolio'

// ADDED: Import the page-specific CSS file here.
import '../../assets/stylesheets/pages/portfolio_index.css'

const container = document.getElementById('portfolio-index-page')
if (container) {
  const root = createRoot(container)
  root.render(
    <BrowserRouter>
      <div>
        <IndexPage />
      </div>
    </BrowserRouter>
  )
}